import { render, staticRenderFns } from "./new_student.vue?vue&type=template&id=598218b4&scoped=true"
import script from "./new_student.vue?vue&type=script&lang=ts"
export * from "./new_student.vue?vue&type=script&lang=ts"
import style0 from "./new_student.vue?vue&type=style&index=0&id=598218b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598218b4",
  null
  
)

export default component.exports